import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    description: Yup.string().required('Descrição é obrigatória'),
    hierarchy: Yup.object()
        .shape({
            value: Yup.string().required('Selecione um Hierarquia'),
        })
        .nullable()
        .required('Hierarquia é obrigatório'),
});